/* eslint-disable react/require-default-props */

import React from "react";
import { Button, CloseIconButton, SvgIcons } from "@tripian/react";
import { useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { LOGIN, TRIP_CLONE } from "../../constants/ROUTER_PATH_TITLE";
import { useGuestUserForSimplyCaribbean } from "../../hooks/useGuestUserForSimplyCaribbean";
import useTranslate from "../../hooks/useTranslate";
import styles from "./CloneModal.module.scss";

type Prop = {
  sharedTripHash: string;
  onCancel: () => void;
  isTimeline?: boolean;
};
export const CloneModal = ({ sharedTripHash, onCancel, isTimeline = false }: Prop) => {
  const { isLoggedIn } = useAuth();
  const navigate = useNavigate();

  const { t } = useTranslate();

  const isGuestForSimplyCaribbean = useGuestUserForSimplyCaribbean();

  const onClone = () => {
    const timelineParam = isTimeline ? "?isTimeline=true" : "";
    if (isLoggedIn) {
      if (isGuestForSimplyCaribbean) {
        navigate(`${LOGIN.PATH}`, {
          state: { fromCloneModal: true },
        });
      } else {
        navigate(`${TRIP_CLONE.PATH}/${sharedTripHash}${timelineParam}`, { replace: true });
      }
    } else {
      navigate(`${LOGIN.PATH}?sharedTripHash=${sharedTripHash}${isTimeline ? "&isTimeline=true" : ""}`);
    }
  };

  return (
    <div id="hebele" className={styles.cloneModal}>
      <div className={styles.dialog}>
        {window.tconfig.LOGIN_WITH_HASH || isGuestForSimplyCaribbean ? (
          <div className="flex h-full flex-col justify-center items-center">
            <div className="flex items-center justify-between w-full md:mb-8 p-2 mb-4">
              <div className="text-2xl font-semibold text-neutral-800">
                {t("cloneTrip.header.login")}
              </div>
              <CloseIconButton
                className="w-6 h-6"
                fill="#2B2B33"
                clicked={onCancel}
              />
            </div>
            <div className="flex flex-row w-full items-center justify-center py-0">
              <Button
                className="w-full"
                color="primary"
                text={t("cloneTrip.login")}
                onClick={onClone}
              />
            </div>
          </div>
        ) : (
          <div className="flex h-full flex-col justify-center items-center">
            <div className="flex items-center justify-between w-full md:mb-6 mb-4">
              <div className="text-2xl font-semibold text-neutral-800">
                {isLoggedIn ? "Make Changes" : t("cloneTrip.header.login")}
              </div>
              <CloseIconButton
                className="w-6 h-6"
                fill="#2B2B33"
                clicked={onCancel}
              />
            </div>
            <div
              className={`flex w-full border rounded-xl overflow-hidden ${isLoggedIn ? "border-yellow-500 mb-8" : "border-[#E9314A]"}`}
            >
              <div
                className={`w-4 rounded-l-lg ${isLoggedIn ? "bg-yellow-500" : "bg-[#E9314A]"}`}
              />
              <div className="flex items-center p-4 space-x-3">
                <SvgIcons.Exclamation
                  fill={isLoggedIn ? "#F59E0B" : "#E9314A"}
                />
                <p
                  className={`font-medium m-0 ${isLoggedIn ? "text-yellow-600" : "text-[#E9314A]"}`}
                >
                  {t("cloneTrip.error")}
                </p>
              </div>
            </div>
            {!isLoggedIn && (
              <div className="flex flex-1 w-full my-8">
                {t("cloneTrip.description")}
              </div>
            )}
            <div className="flex flex-row w-full items-center justify-center py-0">
              <Button
                className="w-full"
                color="primary"
                text={isLoggedIn ? "Duplicate" : t("cloneTrip.login")}
                onClick={onClone}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
